import { useEffect } from "react";

export default function CapabilityStatementPage() {
  useEffect(() => {
    // Redirect to the backend PDF endpoint
    window.location.href = "/api/capability-statement";
  }, []);

  return null;
}
